
import {Vue} from "vue-class-component";
import {Prop} from "vue-property-decorator";

export default class IconHeading3 extends Vue {
}
